<template>
    <section class="small-left">
        <div class="center gray">

            <lottie :name="'chapter-4/usecase-02'" :width="500" :height="745" />

        </div>
        <div class="spacing center">

            <div>

                <h2>5G voice and video bundled with 5G Fixed Wireless Access</h2>

                <p>5G broadband connections offer clear, reliable voice services that can be bundled into a wider Fixed Wireless Access (FWA) package. Homes and small businesses benefit from multimedia applications requiring low latency and gigabit bandwidth. This use case enables you to offer advanced services cost-effectively because no site visits are needed.</p>

                <a href="https://www.nokia.com/networks/solutions/voice-over-5g-vo5g-core/#5g-ecosystem" class="button" target="_blank">Discover the usecase</a>

            </div>

        </div>
    </section>
</template>

<script>

    import globalMixin from '@/mixins/globalMixin.js';

    export default {
        mixins: [globalMixin],
    }

</script>

<style lang="scss" scoped>

    // ...

</style>